import { createFeature, createReducer, on } from '@ngrx/store';
import { MeasuresActions } from '@store/actions/measures/measures.actions';
import { ICriteria, IMeasure, IRuleParentInfo } from '@models/measures.model';
import { IDropdown } from '@models/dropdown.model';

export const measuresFeatureKey = 'measures';

export interface State {
  measuresData: IMeasure[],
  measure: IMeasure ,
  dropDownMeasureAggregationType: IDropdown[],
  dropDownMeasureTypes: IDropdown[],
  criteriaGroup: IDropdown[],
  gridTotal: number,
  criterias: ICriteria[],
  ruleParentInfo: IRuleParentInfo,
  showMeasureDetails: boolean
}

export const initialState: State = {
  measuresData: [],
  dropDownMeasureAggregationType: [],
  dropDownMeasureTypes: [],
  measure: {
    id: 0,
    researchNetworkID: 0,
    registryID: 0,
    title: '',
    description: '',
    eMeasure_Measure_identifier: '',
    nqF_eMeasure_identifier: null,
    nqF_identifier: '',
    qpP_identifier: '',
    measureTypeID: 0,
    highPriority: false,
    measureAggregationTypeID: 0,
    createUserID: 0
  },
  criterias: [],
  gridTotal: 0,
  showMeasureDetails: false,
  ruleParentInfo: {
    criteriaId: 0,
    componentId: 0,
    ruleGroupId: 0
  },
  criteriaGroup: []
};

export const reducer = createReducer(
  initialState,

  on(MeasuresActions.getMeasuresSuccess,(state, action) => ({
    ...state,
    measuresData: action.measuresData,
    gridTotal: action.totalItems
  })),

  on(MeasuresActions.getMeasuresFailure, (state, action) => ({
    ...state,
    measuresData: initialState.measuresData,
    gridTotal: initialState.gridTotal    
  })),

  on(MeasuresActions.clearMeasure, (state, action) => ({
    ...state,
    measure: initialState.measure,
    showMeasureDetails: false,
  })),

  on(MeasuresActions.setMeasureToEdit, (state, action) => ({
    ...state,
    showMeasureDetails: false
  })),

  on(MeasuresActions.setMeasureDetails, (state, action) =>({
    ...state,
    criterias: action.details,
    measure: action.measure,
    showMeasureDetails: true,
  })),

  on(MeasuresActions.loadMeasureAggregationTypes, (state,action) => ({
    ...state,
    dropDownMeasureAggregationType: action.measureAggregationTypes
  })),

  on(MeasuresActions.loadMeasureAggregationFailure, (state,action) => ({
    ...state,
    dropDownMeasureAggregationType: initialState.dropDownMeasureAggregationType
  })),

  on(MeasuresActions.loadMeasureTypes, (state,action) => ({
    ...state,
    dropDownMeasureTypes: action.measureTypes
  })),

  on(MeasuresActions.loadMeasureTypesFailure, (state,action) => ({
    ...state,
    dropDownMeasureTypes: initialState.dropDownMeasureTypes
  })),

  on(MeasuresActions.addNewCriteriaSuccess, (state, action) =>({
    ...state,
    criterias: [...state.criterias, action.criteria],
    canAddCriteria: false
  })),

  on(MeasuresActions.updateCriteriaSuccess, (state, action) =>({
    ...state,
    criterias:  action.criterias,
    canAddCriteria: false
  })),

  on(MeasuresActions.reorderCriteriaListSuccess, (state, action) =>({
    ...state,
    criterias: action.criterias
  })),

  on(MeasuresActions.loadCriteriaGroupTypes, (state, action) =>({
    ...state,
    criteriaGroup: action.criteriaGroupTypes
  })),

  on(MeasuresActions.updateMeasureTitle, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      title: action.title
    }
  })),

  on(MeasuresActions.updateMeasureDescription, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      description: action.description
    }
  })),

  on(MeasuresActions.updateMeasureEcqm, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      eMeasure_Measure_identifier: action.ecqm
    }
  })),

  on(MeasuresActions.updateMeasureQpp, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      qpP_identifier: action.qpp
    }
  })),

  on(MeasuresActions.updateMeasureType, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      measureTypeID: action.measureType
    }
  })),

  on(MeasuresActions.updateMeasurePriority, (state, action) =>({
    ...state,
    measure: {
      ...state.measure,
      highPriority: action.priority
    }
  })),

  on(MeasuresActions.addNewRuleSuccess, (state, action) =>({
    ...state,
    criterias: action.details
  })),

  on(MeasuresActions.reorderRuleListSuccess, (state, action) =>({
    ...state,
    criterias: action.criterias
  })),
);

export const measuresFeature = createFeature({
  name: measuresFeatureKey,
  reducer,
});

